import config from '../../../config';

const baseUrl = `${config.apiUrl()}/Referrals`;
const baseReportsUrl = `${config.apiUrl()}/Reports/Referrals`;

export default {
  referralsUrl: (): string => `${baseUrl}`,
  individualReferralsUrl: (userId: string): string =>
    `${baseUrl}/individual?userId=${encodeURIComponent(userId)}`,
  referralsBulkUrl: (): string => `${baseUrl}/Bulk`,
  cancelReferralsUrl: (): string => `${baseUrl}/cancel`,
  backofficeGetReferralsContentUrl: (): string => `${baseReportsUrl}/SignUpTotals`,
};
